(function () {
    'use strict';

    // @ngInject
    function CompanySettingsTemplatesWrapperControllerCtor($scope, $injector, 
                                                           AnalyticsService, NavigationService, TemplatesViewService) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'TemplatesWrapperController';
        AnalyticsService.trackPageView(this, 'TemplatesWrapperView');
        this.NavigationService = NavigationService;
        this.TemplatesViewService = TemplatesViewService;
    }

    Controllers.CompanySettingsTemplatesWrapperController = Class(Controllers.BaseController, {
        constructor: CompanySettingsTemplatesWrapperControllerCtor
    });
}());
